/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import "../../../../../../components/chat/usendChat.css";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import ClearIcon from "@mui/icons-material/Clear";
import DisputeMessages from "./DisputeMessages";
import { Badge, IconButton, TextField } from "@mui/material";
import { ReactComponent as Message } from "../../../../../../assets/img/message.svg";
import { ReactComponent as DisputePurple } from "../../../../../../assets/img/dummyImg/disputePurple.svg";
import { Icon } from "@iconify/react";

import DisputeMediaSendAsMessage from "./DisputeMediaSendAsMessage";
import { handleFileChange } from "../../utils/checkFIleSizeAndType";
import { toast } from "react-toastify";
import {
  orderSelector,
  setDisputeInfo,
  setDisputeMedia,
} from "../../../../../../redux/slices/orderSlice";
import { useDispatch, useSelector } from "react-redux";
import { authSelector } from "../../../../../../redux/slices/authSlice";
import {
  getConversationsByDispute,
  handleDisputeMessagesAPI,
} from "../../utils/handleDisputeMessagesAPI";
import axiosProtected from "../../../../../../api/config/baseWithToken";
import { checkLastFiveMessages } from "../../utils/checkLastFiveMessagesOfDisputes";

import {
  markAsComplete,
  getAllDisputes,
  updateDispute,
} from "../../../../../../api/order/disputes-admin/";
import { isClientPreview } from "../../../../../../utils/clientPreview";

export default function DisputeMessagingDrawer({ dispute }) {
  const { disputeMedia } = useSelector(orderSelector);
  const { loggedUser } = useSelector(authSelector);
  const dispatch = useDispatch();
  const [sendingMessage, setSendingMessage] = React.useState(false);

  const [state, setState] = React.useState({
    right: false,
  });

  const [messages, setMessages] = React.useState([]);
  const lastMessageRef = React.useRef(null);
  const [message, setMessage] = React.useState("");
  const [fileLink, setFileLink] = React.useState();
  const [isFileLoading, setIsFileLoading] = React.useState(false);

  React.useEffect(() => {
    // Scroll to the last message when messages change
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  React.useEffect(() => {
    if (state.right) {
      const getMessages = async () => {
        const { conversations } = await getConversationsByDispute(dispute._id);
        setMessages(conversations);
      };
      getMessages();
    }
  }, [state]);

  const handleSendMessage = async () => {
    if (
      messages?.length > 4 &&
      checkLastFiveMessages(messages) &&
      loggedUser?.user?.role === "customer"
    ) {
      toast.warn("You cannot send more than five messages consecutively");
    } else {
      setSendingMessage(true);
      const newMessage = {
        id: Math.random().toString(36).substr(2, 9),
        sender: loggedUser?.user.role?.toUpperCase(),
        message: message,
        attachments: disputeMedia?.filter((item) => item) || [],
        createdAt: new Date(),
      };

      const { conversations } =
        newMessage?.message &&
        (await handleDisputeMessagesAPI({
          dispute: dispute?._id,
          order: dispute?.order,
          user: dispute?.user,
          store: dispute?.store,
          conversations: newMessage,
        }));

      setMessages(conversations);
      setSendingMessage(false);
      setMessage("");

      // if (
      //   dispute?.issue === "Proof document" &&
      //   loggedUser?.user.role === "admin"
      // ) {
      //   dispatch(
      //     updateDispute({
      //       disputeId: dispute?._id,
      //       updateDetails: { status: "complete" },
      //     })
      //   );
      // }

      const clientDisputeURL = "/store/dispute-list?page=0&size=50";
      const adminDisputeURL = "/admin/orders/disputes?page=0&size=50";
      const { data } = await axiosProtected.get(
        loggedUser?.user?.role === "admin" ? adminDisputeURL : clientDisputeURL
      );
      dispatch(setDisputeInfo(data));

      dispatch(setDisputeMedia([]));
    }
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const closeDrawer = (anchor) => (event) => {
    event.stopPropagation();
    event.preventDefault();
    setState({ ...state, [anchor]: false });
  };

  const handleTextFieldKeyDown = (event) => {
    // Stop the propagation of the keydown event
    event.stopPropagation();
  };

  const anchor = "right";

  const handelMarkAsComplete = (disputeId) => {
    dispatch(
      markAsComplete({
        disputeId: disputeId,
      })
    ).then(() => {
      dispatch(getAllDisputes({ page: 0, size: 50 }));
    });
  };

  return (
    <div>
      {dispute?.unreadCount ? (
        <Badge badgeContent={dispute?.unreadCount || 0} color="secondary">
          <DisputePurple onClick={toggleDrawer(anchor, true)} />
        </Badge>
      ) : (
        <Message onClick={toggleDrawer(anchor, true)} />
      )}

      <Drawer
        anchor={anchor}
        open={state[anchor]}
        onClose={toggleDrawer(anchor, false)}
        PaperProps={{ className: "usend-chat" }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: 700,
          }}
          role="presentation"
          onClick={(event) => event.stopPropagation()}
          onKeyDown={toggleDrawer(anchor, false)}
        >
          <div className="div1" style={{ flex: "none" }}>
            <div className="flexbox" style={{ margin: "4%" }}>
              <ClearIcon
                onClick={closeDrawer(anchor)}
                style={{ cursor: "pointer" }}
              />
              {isClientPreview() ? (
                <div className="usend-chat__title">
                  <strong>Dispute #{String(dispute?.order?.shopify_order_number || "").replace(/^#/, "")}</strong>
                  <span>{dispute?.issue}</span>
                </div>
              ) : dispute?.unreadCount ? (
                <DisputePurple />
              ) : (
                <Message />
              )}
              <div style={{ display: "flex", alignItems: "center" }}>
                {loggedUser?.user?.role !== "customer" &&
                  dispute?.status !== "complete" &&
                  dispute?.status !== "archived" && (
                    <Button
                      variant="lightblue"
                      className="usend-chat__complete"
                      sx={{
                        width: "auto",
                        background: "rgba(112, 210, 40, 0.31)",
                        color: "green",
                        margin: 0,
                        boxShadow: "none",
                        ":hover": {
                          background: "rgba(112, 210, 40, 0.31)",
                        },
                      }}
                      onClick={() => {
                        handelMarkAsComplete(dispute?._id);
                      }}
                    >
                      Mark as completed
                    </Button>
                  )}
                {loggedUser?.user?.role !== "customer" &&
                  dispute?.status === "pending" && (
                    <Button
                      variant="lightblue"
                      className="usend-chat__awaiting"
                      sx={{
                        width: "auto",
                        margin: "0px 0px 0px 10px",
                        background: "#FFF0F0",
                        // width:"50%"
                        color: "#FF1818",
                        boxShadow: "none",
                        ":hover": {
                          background: "#FFF0F0",
                        },
                      }}
                      onClick={() => {
                        dispatch(
                          updateDispute({
                            disputeId: dispute?._id,
                            updateDetails: {
                              status: "returned",
                              message:
                                "We marked this dispute as awaiting. Any additional questions? Contact your agent.",
                            },
                          })
                        );
                      }}
                    >
                      Awaiting
                    </Button>
                  )}

                <Button
                  variant="deepbluemini"
                  className="usend-chat__status"
                  sx={{
                    background:
                      dispute.conversationStatus === "Waiting"
                        ? "#EAE8ED"
                        : dispute?.status === "complete"
                        ? "#E6DCF6"
                        : dispute?.status === "archived"
                        ? "rgba(112, 210, 40, 0.31)"
                        : dispute.conversationStatus === "Reply"
                        ? "#ecf88e"
                        : `#DBE3FC`,
                    color:
                      dispute.conversationStatus === "Waiting"
                        ? "#a2a2a2"
                        : dispute.status === "complete"
                        ? "#5833A9"
                        : dispute.status === "archived"
                        ? "green"
                        : dispute.conversationStatus === "Reply"
                        ? "#ffcd03"
                        : "#1A3AB8",
                    fontSize: "14px",
                    fontWeight: 700,
                    padding: "8px 20px",
                    width: "auto",
                    borderRadius: "8px",
                    margin: 0,
                    marginLeft: "10px",
                    height: "auto",
                    ":hover": {
                      background: "#EAE8ED",
                    },
                    cursor: "default",
                    boxShadow: "none",
                  }}
                >
                  {dispute?.status === "complete"
                    ? dispute.status
                    : dispute.conversationStatus === "Waiting"
                    ? "Waiting"
                    : dispute.conversationStatus === "Reply"
                    ? "Reply"
                    : dispute.status}
                </Button>
              </div>
            </div>
          </div>

          <Divider />
          <div className="div2" style={{ overflowY: "scroll", flex: "1" }}>
            <DisputeMessages
              profileImg={loggedUser?.user?.img}
              messages={messages}
              disputeRow={dispute}
              lastMessageRef={lastMessageRef}
            />
          </div>
          {((dispute?.status !== "complete" &&
            dispute?.status !== "archived") ||
            loggedUser?.user?.role === "admin") && (
            <div className="div3" style={{ margin: "0 4%", flex: "none" }}>
              <div>
                <div>
                  <TextField
                    placeholder="Write a response"
                    multiline
                    minRows={4}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyDown={handleTextFieldKeyDown}
                    sx={{ width: "100%" }}
                  />
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {!isFileLoading ? (
                      <div>
                        <IconButton
                          aria-label="upload picture"
                          component="label"
                          sx={{
                            ":hover": {
                              background: "#fff",
                            },
                          }}
                          onChange={(e) => {
                            e.stopPropagation();
                            handleFileChange(e) === true
                              ? setFileLink(e.target.files[0])
                              : toast.warn(
                                  "Invalid file. Please select a file that is within 50MB and of type PNG, JPEG, PDF, or MP4."
                                );
                          }}
                          // disabled={isLoading === true}
                        >
                          <input hidden type="file" />
                          <Icon icon="bi:cloud-upload" width="20" height="20" />
                          <h6 style={{ marginLeft: "10px" }}>Upload file</h6>
                        </IconButton>
                        <DisputeMediaSendAsMessage
                          isFileUploading={isFileLoading}
                          setIsFileLoading={setIsFileLoading}
                          fileLink={fileLink}
                          setFileLink={setFileLink}
                        />
                      </div>
                    ) : (
                      <p>File uploading</p>
                    )}
                    <Button
                      variant="lightblue"
                      disabled={message.trim() === "" || sendingMessage}
                      sx={{
                        marginTop: "20px",
                        marginBottom: "20px",
                        width: "auto",
                        background: "#210C43",
                      }}
                      onClick={handleSendMessage}
                    >
                      {isClientPreview() ? "Send" : "Response"}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Box>
      </Drawer>
    </div>
  );
}
